import { View, type ViewProps } from "react-native";

import { cn } from "@/lib/ui/cn";

/**
 * A screen root: `<View className="flex-1 bg-bg">` on the tonal ground.
 *
 * Extra `className` is merged through `cn`, so a screen's own padding or flex behavior wins over
 * the defaults.
 */
export function Screen({ className, ...rest }: ViewProps & { className?: string; }) {
  return <View className={cn("flex-1 bg-bg", className)} {...rest} />;
}
